import { User } from '../organisations/user';

export class Note {
  id: string;
  text: string;
  attachemntsName: string[];
  modifiedOn: string;
  entityId: string | null;
  individualId: string | null;
  userId: string | null;
  user: User | null;

  constructor(data: Partial<Note> = {}) {
    this.id = data.id ?? '';
    this.text = data.text ?? '';
    this.attachemntsName = data.attachemntsName ?? [];
    this.modifiedOn = data.modifiedOn ?? '';
    this.entityId = data.entityId ?? null;
    this.individualId = data.individualId ?? null;
    this.userId = data.userId ?? null;
    this.user = data.user ? new User(data.user) : null;
  }
}
